import React from "react";
import TABDecisionPanel from "../features/tab/TABDecisionPanel";
import DemandPageHeader from "../components/DemandPageHeader";
import DemandSelector from "../components/DemandSelector";
import { useDemandId } from "../context/DemandContext";

export default function TABPage() {
  // Was: no demandId — TABDecisionPanel defaulted to "DEM-001". A board could have
  // recorded a decision against a demand it had never looked at.
  const { demandId, setDemandId } = useDemandId();

  return (
    <div>
      <DemandPageHeader
        title="TAB Decision"
        description="Technical Advisory Board review, conditions and execution target"
        breadcrumbPath="TAB Decision"
      >
        <DemandSelector currentDemandId={demandId} stage="tab" onDemandChange={setDemandId} />
      </DemandPageHeader>
      {demandId ? (
        <TABDecisionPanel demandId={demandId} />
      ) : (
        <div style={{ padding: 40, textAlign: "center", color: "var(--cares-text-label)" }}>
          Select a demand to open its TAB briefing.
        </div>
      )}
    </div>
  );
}
